export enum Viewport {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
  LargeDesktop = 'large_desktop',
  MobileTablet = 'mobile_tablet',
  TabletDesktop = 'tablet_desktop',
  All = 'all',
}
